import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/i18n";

/**
 * Eigene, datenschutzfreundliche Seitenaufruf-Zählung (kein Cookie, keine IP-Speicherung -
 * siehe Kommentar zu /api/track im Backend). Wird nur innerhalb von SiteLayout gerendert,
 * damit Besuche im Admin-Bereich nicht mitgezählt werden.
 */
export function PageTracker() {
  const location = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    api.post("/track", {
      path: location.pathname,
      lang,
      referrer: document.referrer || null,
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
}
